import Backbone from 'backbone';
import TemplateModel from '../model/template';
import DeviceConfig from '../config/devicesConfig.js';
import devices from './devices.js';
var sourceFile = require('../../../config/config.js');
const rootDir = sourceFile.url;
export default Backbone.View.extend({
  initialize(o) {
    this.model = new TemplateModel();
    this.model.set(o.modelData);
    this.groupName = o.group_name;
    this.render();
  },

  render() {
    var { html, css, js } = this.model.toJSON();
    this.$el.append(this.template());
    new devices({
      el: $('#header')
    });
    this.loadTemplateInIframe(html, css, js);
  },

  loadTemplateInIframe(html, css, js) {
    let url = getGeneratedPageURL({
      html: html,
      css: css,
      js: js
    });
    this.iframe = document.querySelector('#marketplace-preview-frame');
    this.iframe.src = url;
  },

  template() {
    return `
          <div class="preview-wrapper">
            <div class="left-pane">
                <div id="header" class="header">
                <div class="header-icon-container">
                </div>
                </div>
                <div class="preview-container">
                <div class="frame">
                    <iframe id="marketplace-preview-frame" src="" frameBorder="0"></iframe>
                </div> 
                </div>
            </div>
            <div class="right-pane">
                <div class="right-header">
                <div class="category-container">
                    <div class="category-name">${this.groupName}</div>
                </div>
                <div class="preview close-button"><img src="${rootDir}/static/images/Console/Close-icon-img.svg"
                    alt="" /></div>
                </div>
                <div class="right-body">
                    <div class="template-name">${this.model.get('name')}</div>
                    <div class="template-description">${this.model.get(
                      'description'
                    )}
                </div>
                    <div class="template-template-by">Provided by : <span class="template-by-name">DronaHQ Studio</span></div>
                    <div class="template-add">Add to Designer</div>
                </div>
            </div>
            </div>
    `;
  },
  addTemplateToBlock(e) {
    editor.BlockManager.add(this.model.get('template_id'), {
      label: `<b>${this.model.get('name')}<b>`,
      icon: this.model.get('image'),
      content: `${this.model.get('html')}
            <style>${this.model.get('css')}</style>
      `,
      category: 'Marketplace'
    });
    this.closePreview(e);
  },
  events: {
    'click .preview-wrapper .close-button': 'closePreview',
    'click .template-add': 'addTemplateToBlock'
  },
  closePreview(e) {
    e.preventDefault();
    e.stopPropagation();
    this.remove();
  }
});

const getGeneratedPageURL = ({ html, css, js }) => {
  const getBlobURL = (code, type) => {
    const blob = new Blob([code], { type });
    return URL.createObjectURL(blob);
  };

  const cssURL = getBlobURL(css, 'text/css');
  const jsURL = getBlobURL(js, 'text/javascript');

  const source = `
    <html>
      <head>
        ${css && `<link rel="stylesheet" type="text/css" href="${cssURL}" />`}
        ${js && `<script src="${jsURL}"></script>`}
      </head>
      <body>
        ${html || ''}
      </body>
    </html>
  `;

  return getBlobURL(source, 'text/html');
};
